import { render, staticRenderFns } from "./AffiliateDetail.vue?vue&type=template&id=23dc4122&scoped=true"
import script from "./AffiliateDetail.vue?vue&type=script&lang=js"
export * from "./AffiliateDetail.vue?vue&type=script&lang=js"
import style0 from "./AffiliateDetail.vue?vue&type=style&index=0&id=23dc4122&prod&lang=scss&scoped=true"
import style1 from "./AffiliateDetail.vue?vue&type=style&index=1&id=23dc4122&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dc4122",
  null
  
)

export default component.exports